import { Box } from "@material-ui/core";
import React from "react";
export var DataTableLayout = function (_a) {
    var table = _a.table, header = _a.header;
    return (React.createElement(Box, null,
        header,
        React.createElement(Box, { mt: header ? 2 : 0 }, table)));
};
